import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import './index.scss';

const CADASTRO_PATH = '/meteorology/fields/trackingforecast/';
const DETAILED_VIEW_PATH = '/meteorology/fields/trackingforecast/detailedview';

export default function TrackingForecastSubTabs() {
  const { pathname } = useLocation();

  return (
    <div className="tf-mobile-sub-tabs-wrapper">
      <div className="tf-mobile-sub-tabs">
        <Link
          to={CADASTRO_PATH}
          className={`tf-mobile-sub-tabs-option${pathname === CADASTRO_PATH ? ' active' : ''}`}
        >
          Cadastro
        </Link>
        <Link
          to={DETAILED_VIEW_PATH}
          className={`tf-mobile-sub-tabs-option${pathname === DETAILED_VIEW_PATH ? ' active' : ''}`}
        >
          Visão Detalhada
        </Link>
      </div>
    </div>
  );
}
